import { Link } from 'react-router-dom';
import '../button.css';

function FloatingControls({
    tableLink,
    enableCancel,
    onCancel,
    formLink,
    onNewForm,
    addNewLabel = 'Add New',
    enablePrint = false,
    onPrint,
    enableDelete = false,
    onDelete,
    homeLink = '/Home',
    showHome = true,
    showSave = true,
}) {
    const bottomMargin = '30px';

  const handleCancelClick = (event) => {
    if (onCancel) {
      event.preventDefault();
      onCancel(event);
    }
  };

  const handlePrintClick = (event) => {
    event.preventDefault();
    if (onPrint) {
      onPrint(event);
    }
  };

  const handleDeleteClick = (event) => {
    event.preventDefault();
    if (onDelete) {
      onDelete(event);
    }
  };

  const handleNewFormClick = (event) => {
    event.preventDefault();
    if (onNewForm) {
      onNewForm(event);
    }
  };

    return (
        <div className="floating-button-bar">
            <div className="social-btn">
                <ul className="text-right" style={{ flexDirection: 'column' }}>
                    {showSave ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }}>
                            <button type="submit" className="google" style={{ borderColor: 'transparent' }} title="SAVE/UPDATE">
                                <i className="fa fa-floppy-o" />
                                <i className="fa fa-floppy-o" />
                            </button>
                        </li>
                    ) : null}
                    {enableCancel ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="CANCEL / RESET">
                            <Link to="" onClick={handleCancelClick} className="facebook">
                                <i className="fa fa-ban" />
                                <i className="fa fa-ban" />
                            </Link>
                        </li>
                    ) : null}
                    {enablePrint ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="PRINT">
                            <Link to="" onClick={handlePrintClick} className="google">
                                <i className="fa fa-print" />
                                <i className="fa fa-print" />
                            </Link>
                        </li>
                    ) : null}
                    {enableDelete ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="DELETE">
                            <Link to="" onClick={handleDeleteClick} className="facebook">
                                <i className="fa fa-trash" />
                                <i className="fa fa-trash" />
                            </Link>
                        </li>
                    ) : null}
                    {(formLink || onNewForm) ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title={addNewLabel.toUpperCase()}>
                            {onNewForm ? (
                                <button
                                    type="button"
                                    className="google"
                                    style={{ borderColor: 'transparent' }}
                                    onClick={handleNewFormClick}
                                >
                                    <i className="fa fa-plus" />
                                    <i className="fa fa-plus" />
                                </button>
                            ) : (
                                <Link to={formLink} className="google">
                                    <i className="fa fa-plus" />
                                    <i className="fa fa-plus" />
                                </Link>
                            )}
                        </li>
                    ) : null}
                    {tableLink ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="TABLE / VIEW LIST">
                            <Link to={tableLink} className="facebook">
                                <i className="fa fa-eye" />
                                <i className="fa fa-eye" />
                            </Link>
                        </li>
                    ) : null}
                    {showHome ? (
                        <li className="text-center" title="HOME">
                            <Link to={homeLink} className="twitter">
                                <i className="fa fa-home" />
                                <i className="fa fa-home" />
                            </Link>
                        </li>
                    ) : null}
                </ul>
            </div>
        </div>
    );
}

export default FloatingControls;
